"use client";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SEOProvider } from "./components/seo/SEO";
import IndexPage from "./pages/Index";

function App() {
  return (
    <Router>
      <SEOProvider>
        <ThemeProvider>
          <LanguageProvider>
            <IndexPage />
          </LanguageProvider>
        </ThemeProvider>
      </SEOProvider>
    </Router>
  );
}

export default App;